import { CHECKLISTS_API_URL, CHECKLISTS_URL } from 'constants/ApiConstants';
import * as actionTypes from 'modules/checklists/actionTypes';
import type {
  FetchChecklistAdviceHistoryAction,
  FetchChecklistAdviceHistorySuccessAction,
  UpdateAdviceStateAction,
} from 'modules/checklists/types';
import type { DetailedChecklistAdviceHistory } from 'modules/checklists/types/projections/detailed-checklist-advice-history';
import type { MetaAction } from 'modules/global/generic.types';

export const updateAdviceState = (
  { checklistId, adviceId, ...data }: { checklistId: string; adviceId: string; state: string },
  meta: MetaAction = {}
): UpdateAdviceStateAction => ({
  type: actionTypes.PATCH_ADVICE_STATE,
  payload: {
    request: {
      method: 'PATCH',
      url: `${CHECKLISTS_API_URL}/${checklistId}/advices/${adviceId}`,
      data,
    },
  },
  meta: {
    adviceId,
    checklistId,
    ...meta,
  },
});

export const fetchChecklistAdviceHistory = (
  checklistId: string,
  adviceId: string,
  meta: MetaAction = {}
): FetchChecklistAdviceHistoryAction => ({
  type: actionTypes.FETCH_CHECKLIST_ADVICE_HISTORY,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLISTS_URL}/${checklistId}/advices/${adviceId}/history`,
    },
    checklistId,
    adviceId,
  },
  meta,
});

export const fetchChecklistAdviceHistorySuccess = (
  checklistId: string,
  adviceId: string,
  content: DetailedChecklistAdviceHistory[],
  meta: MetaAction = {}
): FetchChecklistAdviceHistorySuccessAction => ({
  type: actionTypes.FETCH_CHECKLIST_ADVICE_HISTORY_SUCCESS,
  payload: {
    checklistId,
    adviceId,
    content,
  },
  meta,
});
